(ns app.front.view.group.admin.permit-type-config
  (:require [app.domain.group.config.model :as config-model]
            [app.domain.group.model :as group-model]
            [app.domain.group.permit-type-config.model :as ptc-model]
            [app.domain.public-notice.model :as public-notice-model]
            [app.domain.workspace.model :as workspace-model]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.action-buttons :as ui-action-buttons]
            [app.front.ui.i18n :as ui-i18n]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.ui.select :as ui-select]
            [app.front.util :as futil :refer [for-frag]]
            [app.front.view.group.admin.allow-workspace-creation-select :as allow-workspace-creation-select]
            [app.front.view.group.admin.archive-on-finish-select :as arch-on-fin-select]
            [app.front.view.group.admin.archiving-config :as archiving-config]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.config.copy-group-config :as copy-gc]
            [app.front.view.group.admin.default-work-type-target :as default-work-type-target]
            [app.front.view.group.admin.pre-consultation-select :as pre-cons-select]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.system-of-units.neighbour-radius-defaults :as neighbour-subs]
            [app.front.view.system-of-units.toggle :as sou-toggle]
            [app.i18n.model :as i18n-model]
            [clojure.data :as cd]
            [clojure.set :as set]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.i18n :as i18n]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))


(rf/reg-event-db ::cleanup #(dissoc % ::data))


(rf/reg-event-db ::set-open-category
  (fn [db [_ ptc-id cat-id]]
    (assoc-in db [::data ::open-category ptc-id] cat-id)))


(rf/reg-event-db ::set-open-work-type
  (fn [db [_ ptc-id wt-id]]
    (assoc-in db [::data ::open-work-type ptc-id] wt-id)))


(rf/reg-event-db ::set-open-work-target
  (fn [db [_ ptc-id wt-id]]
    (assoc-in db [::data ::open-work-target ptc-id] wt-id)))


(rf/reg-sub ::data :-> ::data)


(rf/reg-sub ::open-category
  :<- [::data]
  (fn [data [_ ptc-id]]
    (get-in data [::open-category ptc-id])))


(rf/reg-sub ::open-work-type
  :<- [::data]
  (fn [data [_ ptc-id]]
    (get-in data [::open-work-type ptc-id])))


(rf/reg-sub ::open-work-target
  :<- [::data]
  (fn [data [_ ptc-id]]
    (get-in data [::open-work-target ptc-id])))


(rf/reg-sub ::valid-neighbour-radii?
  (fn [[_ ptc-id]]
    [(rf/subscribe [::gas/permit-type-config-edits ptc-id])
     (rf/subscribe [::neighbour-subs/max-neighbour-radius])])
  (fn [[edits max-radius]]
    (if max-radius
      (->> edits
           :group-config-settings
           vals
           (keep :group.config/neighbour-radius)
           (every? (partial workspace-model/valid-neighbour-radius? max-radius)))
      true)))


(rf/reg-event-db ::set-adding-new
  (fn [db [_ parent-id process-flows category?]]
    (cond-> (assoc-in db [::data ::adding-new parent-id] true)
      (and category?
           (-> process-flows count (= 1))) (assoc-in [::data ::new-permit-subtype-process-flow parent-id] (first process-flows)))))


(rf/reg-event-db ::cancel-adding-new
  (fn [db [_ parent-id]]
    (-> (update-in db [::data ::adding-new] dissoc parent-id)
        (update ::data dissoc ::new-permit-subtype-names ::new-permit-subtype-process-flow))))


(rf/reg-sub ::adding-new?
  :<- [::data]
  (fn [data [_ parent-id]]
    (boolean (get-in data [::adding-new parent-id]))))


(rf/reg-event-db ::edit-new-permit-subtype-name
  (fn [db [_ parent-id type-name]]
    (assoc-in db [::data ::new-permit-subtype-names parent-id] type-name)))


(rf/reg-event-db ::edit-new-permit-subtype-process-flow
  (fn [db [_ parent-id process-flow]]
    (assoc-in db [::data ::new-permit-subtype-process-flow parent-id] process-flow)))


(rf/reg-sub ::new-permit-subtype-names
  :<- [::data]
  (fn [data [_ parent-id]]
    (get-in data [::new-permit-subtype-names parent-id])))


(rf/reg-sub ::new-permit-subtype-process-flow
  :<- [::data]
  (fn [data [_ parent-id]]
    (get-in data [::new-permit-subtype-process-flow parent-id])))


(rf/reg-event-db ::set-permit-subtype-edited-names
  (fn [db [_ config-id type-name]]
    (if (nil? type-name)
      (p/dissoc-in db [::data ::edited-permit-subtype-names config-id])
      (assoc-in db [::data ::edited-permit-subtype-names config-id] type-name))))


(rf/reg-event-db ::set-permit-subtype-edited-process-flow
  (fn [db [_ config-id process-flow]]
    (if (nil? process-flow)
      (p/dissoc-in db [::data ::edited-permit-subtype-process-flow config-id])
      (assoc-in db [::data ::edited-permit-subtype-process-flow config-id] process-flow))))


(rf/reg-sub ::edited-permit-subtype-names
  :<- [::data]
  (fn [data [_ config-id]]
    (get-in data [::edited-permit-subtype-names config-id])))


(rf/reg-sub ::edited-permit-subtype-process-flow
  :<- [::data]
  (fn [data [_ config-id]]
    (get-in data [::edited-permit-subtype-process-flow config-id])))


(rf/reg-sub ::ptc-settings-in-db
  (fn [[_ permit-type ptc-id]]
    [(rf/subscribe [::gas/group-config-settings-for-ptc-editor permit-type])
     (rf/subscribe [::entities/entity ptc-id])
     (rf/subscribe [::i18n/tempura-tr-quiet])])
  (fn [[group-config-settings {:permit-type-config/keys [permit-type hidden? permit-type-descriptions]} tr] _]
    {:group-config-settings    group-config-settings
     :permit-type-descriptions (i18n-model/strings-map
                                 permit-type-descriptions
                                 (when-not hidden?
                                   ;; Always translate to default dictionary, so that we don't put current UI language
                                   ;; as default lang. Would be better to set default for all group languages, but we
                                   ;; don't have the dictionary loaded for additional languages by default.
                                   (tr [i18n-model/default-lang]
                                       [(keyword "application-type.description" (name permit-type))])))}))


(rf/reg-sub ::ptc-settings-in-editor
  (fn [[_ permit-type ptc-id]]
    [(rf/subscribe [::ptc-settings-in-db permit-type ptc-id])
     (rf/subscribe [::gas/permit-type-config-edits ptc-id])])
  (fn [[ptc-settings-in-db ptc-edits]]
    (reduce (fn [acc [k v]]
              (cond-> acc
                (nil? (get acc k))
                ;; Replace unedited values with originals.
                ;; Note that updated config will contain only the edited values after the first edit
                ;; as original and updated config are NOT merged
                (assoc k v)))
            ptc-edits
            ptc-settings-in-db)))


(rf/reg-sub ::group-config-changes-in-editor
  (fn [[_ ptc-id]]
    (rf/subscribe [::gas/permit-type-config-edits ptc-id]))
  :-> :group-config-settings)


(rf/reg-sub ::valid-settings?
  (fn [[_ ptc-id]]
    [(rf/subscribe [::group-config-changes-in-editor ptc-id])
     (rf/subscribe [::valid-neighbour-radii? ptc-id])])
  (fn [[gc-changes valid-radii?]]
    (and (<sub [::default-work-type-target/valid-setting-changes? gc-changes])
         valid-radii?)))


(rf/reg-sub ::permit-type-config-changed?
  (fn [[_ permit-type ptc-id]]
    [(rf/subscribe [::ptc-settings-in-editor permit-type ptc-id])
     (rf/subscribe [::ptc-settings-in-db permit-type ptc-id])])
  (fn [[updated original] _]
    (->> [updated original]
         (map #(select-keys % gas/permit-type-config-editable-keys))
         (apply cd/diff)
         drop-last
         (some some?))))


(rf/reg-sub ::archiving-field-schemas
  (fn [[_ permit-type]]
    (rf/subscribe [::gas/root-group-config permit-type]))
  (fn [root-group-config _]
    (->> root-group-config
         :group.config/archiving-field-configs
         (map :archiving-field/schema)
         (sort-by :ordered/order))))


(rf/reg-event-fx ::create-permit-subtype
  (fn [_ [_ group-id parent-config-id names process-flow success-msg]]
    {:comm/command {:command    :group/create-permit-subtype
                    :method     :post
                    :notify     {:success success-msg}
                    :on-success [::create-permit-subtype.success parent-config-id]
                    :data       (p/assoc-if
                                  (util/mmap {:group.config/names names}
                                             group-id
                                             parent-config-id)
                                  :group.config/process-flow process-flow)}}))


(rf/reg-event-fx ::create-permit-subtype.success
  (fn [{:keys [db]} [_ parent-id status response]]
    {:db       (-> (p/dissoc-in db [::data ::new-permit-subtype-names parent-id])
                   (p/dissoc-in [::data ::new-permit-subtype-process-flow parent-id])
                   (p/dissoc-in [::data ::adding-new parent-id]))
     :dispatch [::entities/apply-changes status response]}))


(rf/reg-event-fx ::save-permit-subtype-changes
  (fn [_ [_ group-id config-id names process-flow success-msg]]
    {:comm/command {:command    :group/edit-permit-subtype
                    :method     :post
                    :notify     {:success success-msg}
                    :on-success [::save-permit-subtype-changes.success config-id]
                    :data       (p/assoc-if
                                  (util/mmap {:group.config/names names}
                                             group-id
                                             config-id)
                                  :group.config/process-flow process-flow)}}))


(rf/reg-event-fx ::save-root-permit-type-changes
  (fn [_ [_ group-id config-id config-changes success-msg]]
    (when-not (empty? config-changes)
      {:comm/command {:command    :group/set-group-configs
                      :method     :post
                      :notify     {:success success-msg}
                      :on-success [::save-permit-subtype-changes.success config-id]
                      :data       {:group-id       group-id
                                   :config-changes {config-id config-changes}}}})))


(rf/reg-event-fx ::save-permit-subtype-changes.success
  (fn [{:keys [db]} [_ config-id status response]]
    {:db       (-> (p/dissoc-in db [::data ::edited-permit-subtype-names config-id])
                   (p/dissoc-in [::data ::edited-permit-subtype-process-flow config-id]))
     :dispatch [::entities/apply-changes status response]}))


(rf/reg-event-fx ::delete-permit-subtype
  (fn [_ [_ group-id config-id success-msg]]
    {:comm/command {:command    :group/delete-permit-subtype
                    :method     :post
                    :notify     {:success success-msg}
                    :on-success [::delete-permit-subtype.success config-id]
                    :data       (util/mmap group-id config-id)}}))


(rf/reg-event-fx ::delete-permit-subtype.success
  (fn [{:keys [db]} [_ config-id status response]]
    {:db       (p/dissoc-in db [::data ::edited-permit-subtype-names config-id])
     :dispatch [::entities/apply-changes status response]}))


(defn pre-consultation-enabled-for-the-cat? [config selected-settings]
  (let [saved-value   (:group.config/pre-consultation config)
        current-value (get-in selected-settings
                              [(:db/id config) :group.config/pre-consultation]
                              saved-value)]
    (contains? #{:group.config.pre-consultation/optional :group.config.pre-consultation/required} current-value)))

(defn subtype-editor
  [{:keys [tr lang config-level heading-text names process-flow set-edited-names-evt set-edited-process-flow-evt
           cancel-evt save-evt delete-evt process-flows category? disabled? permit-type]                         :as props}]
  (let [config-level-text     (tr [config-level])
        group-has-complaints? (->> (:group-config props)
                                   :group.config/group
                                   group-model/get-permit-types
                                   (set/intersection ptc-model/permit-types-with-complaints)
                                   seq)
        cr-work-type?         (and (= permit-type :permit-type/CR)
                                   (= config-level :group-config.level/work-type))]
    [:div.p-4.bg-ui-blue-10.border-2.border-solid.border-ui-blue-100.rounded-md.shadow-lg.animation-appear-slide-down
     (when heading-text
       [:div.flex.flex-col.lg:flex-row
        [:h4 heading-text]])
     (when (and (= config-level :group-config.level/category)
                (> (count process-flows) 1))
       [:div.flex.flex-col.lg:flex-row
        [ui-select/select
         {:id           "new-subtype-process-flow"
          :label-text   (tr [:group-admin/process-flow])
          :val->str     #(tr [%])
          :allow-empty? true
          :class        "full-width-select"
          :empty-text   (tr [:group-admin/select-process-flow])
          :value        process-flow
          :on-change    #(>evt (conj set-edited-process-flow-evt %))
          :required     category?
          :disabled     false
          :light        true
          :values       process-flows}]])
     [:div.flex.flex-col.lg:flex-row
      [ui-i18n/localized-string-edit
       {:label-text          (tr [:group-admin/add-permit-subtype-name-label]
                                 [config-level-text])
        :strings             names
        :on-change           #(rf/dispatch-sync (conj set-edited-names-evt %))
        :allowed-locales-sub ::gas/allowed-locales}]]
     [:div.flex.flex-wrap.justify-between.mt-8.lg:mt-4.items-baseline
      [:div
       [ui-i18n/edit-language-selector {:allowed-locales-sub ::gas/allowed-locales}]]
      [:div.flex.flex-wrap
       (when delete-evt
         [ui/modal-confirmation-button {:trigger-button-opts {:kind       :danger
                                                              :size       :small
                                                              :class-name "mr-2"}
                                        :trigger-button-text (tr [:delete])
                                        :tr                  tr
                                        :on-yes-click        #(>evt delete-evt)}
          [:div
           [:p (tr [(if group-has-complaints?
                      :group-admin/delete-permit-subtype-confirmation-with-complaints
                      :group-admin/delete-permit-subtype-confirmation)]
                   [(i18n-model/get-text-from-entities-or-map names lang)])]
           (when cr-work-type?
             [:p.mt-2 (tr [:group-admin/delete-cr-work-type-registration-warning])])]])
       (cc/button
         {:on-click   #(>evt cancel-evt)
          :kind       :tertiary
          :size       :small
          :class-name "mr-2"}
         (tr [:cancel]))
       (cc/button
         {:on-click #(>evt save-evt)
          :kind     :primary
          :size     :small
          :disabled (if (contains? props :disabled?)
                      disabled?
                      (->> names vals (not-any? seq)))}
         (tr [:save]))]]]))


(defn existing-subtype-editor [{:keys [group-config selected-settings ptc-id config-id tr config-level group-id lang permit-type]}]
  (let [names             (<sub [::edited-permit-subtype-names config-id])
        process-flow      (<sub [::edited-permit-subtype-process-flow config-id])
        process-flows     (<sub [::gas/process-flows permit-type])
        config-level-text (tr [config-level])]
    [subtype-editor (util/mmap {:set-edited-names-evt        [::set-permit-subtype-edited-names config-id]
                                :set-edited-process-flow-evt [::set-permit-subtype-edited-process-flow config-id]
                                :cancel-evt                  [::set-permit-subtype-edited-names config-id nil]
                                :save-evt                    [::save-permit-subtype-changes
                                                              group-id
                                                              config-id
                                                              names
                                                              process-flow
                                                              (tr [:group-admin/edit-permit-subtype-success]
                                                                  [config-level-text])]
                                :delete-evt                  [::delete-permit-subtype
                                                              group-id
                                                              config-id
                                                              (tr [:group-admin/delete-permit-subtype-success]
                                                                  [config-level-text])]
                                :category?                   (= config-level :group-config.level/category)}
                               names tr lang config-level process-flows process-flow permit-type
                               selected-settings group-config ptc-id)]))


(defn permit-type-label-editor [{:keys [group-config config-id tr config-level group-id lang]}]
  (let [names             (<sub [::edited-permit-subtype-names config-id])
        config-level-text (tr [config-level])]
    [subtype-editor (util/mmap {:set-edited-names-evt [::set-permit-subtype-edited-names config-id]
                                :cancel-evt           [::set-permit-subtype-edited-names config-id nil]
                                :save-evt             [::save-root-permit-type-changes
                                                       group-id
                                                       config-id
                                                       (p/assoc-if {}
                                                                   :group.config/names
                                                                   (when-not (= names (-> group-config :group.config/names i18n-model/strings-map))
                                                                     names))
                                                       (tr [:group-admin/edit-permit-subtype-success]
                                                           [config-level-text])]
                                :category?            (= config-level :group-config.level/category)
                                :disabled?            (= names (-> group-config :group.config/names i18n-model/strings-map))}
                               names tr lang config-level group-config)]))


(defn new-subtype-editor [{:keys [parent-id tr config-level group-id permit-type]}]
  (let [process-flows (<sub [::gas/process-flows permit-type])
        category?     (= config-level :group-config.level/category)]
    [:div.mt-4
     (if (<sub [::adding-new? parent-id])
       (let [names             (<sub [::new-permit-subtype-names parent-id])
             process-flow      (<sub [::new-permit-subtype-process-flow parent-id])
             config-level-text (tr [config-level])]
         [subtype-editor (util/mmap {:set-edited-names-evt        [::edit-new-permit-subtype-name parent-id]
                                     :set-edited-process-flow-evt [::edit-new-permit-subtype-process-flow parent-id]
                                     :cancel-evt                  [::cancel-adding-new parent-id]
                                     :save-evt                    [::create-permit-subtype
                                                                   group-id
                                                                   parent-id
                                                                   names
                                                                   process-flow
                                                                   (tr [:group-admin/add-permit-subtype-success]
                                                                       [config-level-text])]
                                     :heading-text                (tr [:group-admin/add-permit-subtype-title]
                                                                      [(str/lower-case config-level-text)])}
                                    names tr config-level process-flows process-flow category?)])
       (cc/button
         {:kind     :tertiary
          :size     :small
          :icon     i/plus
          :on-click #(>evt [::set-adding-new parent-id process-flows category?])}
         (tr [:group-admin/add-permit-subtype-button]
             [(tr [config-level])])))]))


(defn group-config-rt-editor [{:keys [ptc-id group-config attr default-value selected-settings]}]
  (let [config-id     (:db/id group-config)
        saved-value   (or (get group-config attr)
                          default-value)
        current-value (get-in selected-settings [config-id attr]
                              saved-value)]
    [:div {:on-click #(.stopPropagation %)}
     [ui-rt/editor-legacy {:id            (str config-id "-" (name attr))
                           :initial-value current-value
                           :on-change     (fn [value]
                                            (>evt [::gas/update-ptc-group-config-changes
                                                   ptc-id
                                                   config-id
                                                   #(if (= saved-value value)
                                                      (dissoc % attr)
                                                      (assoc % attr value))
                                                   true]))}]]))


(defn phase-instructions-editor [{:keys [ptc-id category-config selected-settings]} phase-entity-type]
  (let [attr                                               :group.config/instructions-text-for-phases
        {:keys [:group.config/instructions-text-for-phases
                :db/id]}                                   category-config
        saved-value                                        (some-> instructions-text-for-phases phase-entity-type)
        current-value                                      (get-in selected-settings [id attr phase-entity-type]
                                                                   saved-value)]
    [:div {:on-click #(.stopPropagation %)}
     [ui-rt/editor-legacy {:initial-value current-value
                           :id            (str phase-entity-type "-instructions")
                           :on-change     (fn [value]
                                            (let [new-value (when-not (ui-rt/empty-texts? value)
                                                              value)]
                                              (>evt [::gas/update-ptc-group-config-changes
                                                     ptc-id
                                                     id
                                                     (fn [{old-instr-map :group.config/instructions-text-for-phases
                                                           :as           gc-changes}]
                                                       (let [instr-map (-> (if (nil? new-value)
                                                                             ;; Remove the key from map if this text is now empty,
                                                                             ;; set attr as nil if the map is now empty
                                                                             (dissoc old-instr-map phase-entity-type)
                                                                             ;; Set new text value
                                                                             (assoc old-instr-map phase-entity-type new-value))
                                                                           not-empty)]
                                                         (if (= instr-map instructions-text-for-phases)
                                                           ;; Remove the change if we match value in db
                                                           (dissoc gc-changes attr)
                                                           (assoc gc-changes attr instr-map))))])))}]]))


(defn group-config-enabled-checkbox
  [{:keys [tr lang ptc-id group-config selected-settings open? editor-x-padding crud-allowed? permit-type]}]
  (let [config-id (:db/id group-config)
        editing?  (seq (<sub [::edited-permit-subtype-names config-id]))]
    (if (and open? editing? crud-allowed?)
      [:div.py-2.w-full
       {:on-click #(.stopPropagation %)
        :class    (or editor-x-padding "px-5")}
       [existing-subtype-editor (util/mmap {:group-id     (-> group-config :group.config/group :db/id)
                                            :config-level (-> group-config :group.config/level)}
                                           group-config selected-settings ptc-id config-id tr lang permit-type)]]
      [:div.flex {:on-click #(.stopPropagation %)}
       (cc/checkbox {:id         (str config-id "-enabled")
                     :label-text (config-model/localized-name group-config lang)
                     :checked    (= (get-in selected-settings
                                            [config-id :domain/state]
                                            (:domain/state group-config))
                                    :group-config.state/enabled)
                     :on-change  (fn [v]
                                   (let [new-value (if v
                                                     :group-config.state/enabled
                                                     :group-config.state/disabled)]
                                     (>evt [::gas/update-ptc-group-config-changes
                                            ptc-id
                                            config-id
                                            #(if (= (:domain/state group-config) new-value)
                                               (dissoc % :domain/state)
                                               (assoc % :domain/state new-value))])))})
       (when (and crud-allowed? open?)
         (cc/button
           {:class-name       "only-icon-button ml-2"
            :kind             :ghost
            :size             :small
            :icon             i/pen
            :icon-description (tr [:edit])
            :icon-position    :right
            :on-click         #(do (>evt [::set-permit-subtype-edited-names
                                          config-id
                                          (-> group-config :group.config/names i18n-model/strings-map)])
                                   (>evt [::set-permit-subtype-edited-process-flow
                                          config-id
                                          (-> group-config :group.config/process-flow)]))}
           ""))])))


(defn system-name-indicator [{:keys [tr lang group-config]}]
  [:div.py-1
   (when-let [system-name (some-> group-config
                                  :group.config/target
                                  vector
                                  tr)]
     (when (not= (config-model/localized-name group-config lang)
                 system-name)
       [:div.mb-2.uppercase.text-xs.mr-2
        (str (tr [:group-admin/permit-subtype-default-name]) ": " system-name)]))])


(defn work-target-config-editor
  [{:keys [work-target-config ancestor-configs ptc-id selected-settings tr lang crud-allowed? permit-type]}]
  (let [wt-id (:db/id work-target-config)
        open? (= (<sub [::open-work-target ptc-id]) wt-id)]
    [:div.p-3.border.border-grey.border-solid
     {:class (if open? "bg-grey-tint-7" "bg-white")}
     [:div.flex.justify-between.items-start.cursor-pointer
      {:on-click #(>evt [::set-open-work-target ptc-id (when-not open? wt-id)])}
      [group-config-enabled-checkbox (util/mmap {:group-config     work-target-config
                                                 :editor-x-padding "px-0"}
                                                lang ptc-id selected-settings tr open? crud-allowed? permit-type)]
      (cc/icon
        {:icon        (if open? i/chevron-up i/chevron-down)
         :class-name  "mt-2"
         :description (tr [:review.config/selected-review-config])})]
     (when open?
       [:div.px-4.pb-4.animation-appear-slide-down
        {:on-click #(.stopPropagation %)}
        [system-name-indicator (util/mmap {:group-config work-target-config}
                                          tr lang)]
        [allow-workspace-creation-select/allow-workspace-creation-selector
         (util/mmap {:config work-target-config} ancestor-configs tr ptc-id selected-settings permit-type)]])]))


(defn work-type-config-editor
  [{:keys [permit-type ptc-id work-type-config selected-settings tr lang group-id crud-allowed? ancestor-configs]}]
  (let [wt-id                 (:db/id work-type-config)
        work-targets          (seq (<sub [::gas/child-group-configs-sorted wt-id #{:group-config.state/enabled
                                                                                   :group-config.state/disabled}]))
        is-target-applicable? (not (contains? ptc-model/permit-types-with-multiple-work-types permit-type))
        open?                 (= (<sub [::open-work-type ptc-id])
                                 wt-id)]
    [:div.p-3.border.border-grey.border-solid
     {:class (if open? "bg-grey-tint-7" "bg-white")}
     [:div.flex.justify-between.items-start.cursor-pointer
      {:on-click #(>evt [::set-open-work-type ptc-id (when-not open? wt-id)])}
      [group-config-enabled-checkbox (util/mmap {:group-config work-type-config}
                                                lang ptc-id selected-settings tr open? crud-allowed? permit-type)]
      [:div {:center "right"}
       (when crud-allowed?
         [copy-gc/copy-gc-button tr work-type-config])
       (cc/icon
         {:icon        (if open? i/chevron-up i/chevron-down)
          :class-name  "mt-2 ml-2"
          :description (tr [:review.config/selected-review-config])})]]
     (when open?
       [:div.px-4.pb-4.animation-appear-slide-down
        {:on-click #(.stopPropagation %)}
        [system-name-indicator (util/mmap {:group-config work-type-config}
                                          tr lang)]
        [allow-workspace-creation-select/allow-workspace-creation-selector
         (util/mmap {:config work-type-config} ancestor-configs tr ptc-id selected-settings permit-type)]
        (when (or (and is-target-applicable? work-targets)
                  crud-allowed?)
          [:<>
           [:h5.mb-2 (tr [:work-targets])]
           (for-frag [work-target-config work-targets]
             [work-target-config-editor (util/mmap {:ancestor-configs (conj ancestor-configs work-type-config)}
                                                   work-target-config lang ptc-id selected-settings tr open?
                                                   crud-allowed? permit-type)])
           (when crud-allowed?
             [new-subtype-editor (util/mmap {:parent-id    (:db/id work-type-config)
                                             :config-level :group-config.level/work-target}
                                            permit-type
                                            group-id
                                            tr)])])])]))

(defn visibility-limited? [config selected-settings]
  (let [config-id (:db/id config)
        limited?  (get-in selected-settings
                          [config-id :group.config/limit-visibility-for-other-departments?]
                          (:group.config/limit-visibility-for-other-departments? config))]
    (boolean limited?)))

(defn visibility-checkbox
  [{:keys [ptc-id
           category-config
           permit-type-group-config
           selected-settings
           tr]}]
  (let [restrict-sibling-enabled? (<sub [::ff/enabled? :feature-flag.id/restrict-workspace-access-to-sibling-authorities])
        category-limited?         (visibility-limited? category-config selected-settings)
        ptc-limited?              (visibility-limited? permit-type-group-config selected-settings)
        target-config-id          (:db/id (or category-config permit-type-group-config))
        limited?                  (if restrict-sibling-enabled?
                                    (or ptc-limited? category-limited?)
                                    category-limited?)]
    [:div.mb-4 {:on-click #(.stopPropagation %)}
     (cc/checkbox {:id         (str "limit-visibility-" ptc-id "-" target-config-id)
                   :class-name "mr-2"
                   :label-text (tr [:group.config/limit-visibility-for-other-departments?])
                   :checked    (boolean limited?)
                   :disabled   (boolean (and restrict-sibling-enabled?
                                             ptc-limited?
                                             category-config))
                   :on-change  (fn [value]
                                 (>evt [::gas/update-ptc-group-config-changes
                                        ptc-id
                                        target-config-id
                                        #(assoc % :group.config/limit-visibility-for-other-departments? value)]))})
     (when limited?
       [:<>
        [ui/help (tr [:group-admin/limit-visibility-note]) {:color :white}]
        (when (or (not category-config) (and restrict-sibling-enabled? (not ptc-limited?)))
          [:<>
           [:h4.mt-4.mb-2 (tr [:group-admin/limit-visibility-help])]
           [:p (tr [:group-admin/limit-visibility-help-instructions])]
           [:div {:on-click #(.stopPropagation %)}
            [group-config-rt-editor (util/mmap {:group-config (or category-config permit-type-group-config)
                                                :attr         :group.config/limit-visibility-help}
                                               selected-settings
                                               ptc-id)]]])])]))

(defn category-config-editor
  [{:keys [ptc-id permit-type category-config updated-ptc-config hidden? tr
           archiving-feature? archiving-field-schemas group-id crud-allowed? permit-type-group-config
           any-project-types?]}]
  (let [lang                         (<sub [:language])
        cat-id                       (:db/id category-config)
        ;; System default categories have the old keyword categories
        cat-keyword                  (:group.config/target category-config)
        open?                        (= (<sub [::open-category ptc-id])
                                        cat-id)
        selected-settings            (:group-config-settings updated-ptc-config)
        permit-type-ce?              (= permit-type :permit-type/CE)
        permit-type-pwo?             (= permit-type :permit-type/PWO)
        permit-type-pi?              (= permit-type :permit-type/PI)
        restrict-sibling-enabled?    (<sub [::ff/enabled? :feature-flag.id/restrict-workspace-access-to-sibling-authorities])
        complaint-submission-config? (<sub [::ff/enabled? :feature-flag.id/complaint-submission-configuration])
        application-wizard?          (<sub [::ff/enabled? :feature-flag.id/application-wizard])]
    [:div.p-3.border.border-grey.border-solid
     {:data-cy  "permit-type-row"
      :class    (if open? "bg-grey-tint-7" "bg-white")
      :on-click #(>evt [::set-open-category ptc-id (when-not open? cat-id)])}
     [:div.flex.justify-between.items-start.cursor-pointer
      {:on-click #(>evt [::set-open-category ptc-id (when-not open? cat-id)])}
      (if hidden?
        [:div.py-2
         (config-model/localized-name category-config lang)]
        [group-config-enabled-checkbox (util/mmap {:group-config category-config}
                                                  lang ptc-id selected-settings tr open? crud-allowed? permit-type)])
      [:div {:center "right"}
       (when crud-allowed?
         [copy-gc/copy-gc-button tr category-config])
       (cc/icon
         {:icon        (if open? i/chevron-up i/chevron-down)
          :data-cy     "extend-row"
          :class-name  "mt-2 ml-2"
          :description (tr [(if open?
                              :carbon.table.row.collapse
                              :carbon.table.row.expand)])})]]
     (when open?
       [:div.px-5.pb-5.animation-appear-slide-down {:on-click #(.stopPropagation %)}
        [system-name-indicator (util/mmap {:group-config category-config}
                                          tr lang)]

        (when-not hidden?
          [:<>
           ;; Wizard visibility
           [allow-workspace-creation-select/allow-workspace-creation-selector
            (util/mmap {:config           category-config
                        :ancestor-configs []}
                       tr ptc-id selected-settings permit-type)]

           ;; Pre-consultation dropdown
           (when-not (contains? ptc-model/no-pre-consultation-types permit-type)
             [:<>
              [pre-cons-select/pre-consultation-selector
               (util/mmap tr ptc-id permit-type category-config selected-settings)]
              (when (pre-consultation-enabled-for-the-cat? category-config selected-settings)
                [:<>
                 [:h4.mt-4.mb-2 (tr [:group-admin/instructions-for-pre-consultation])]
                 [:p.p-0 (tr [:group-admin/instructions-for-pre-consultation-help-text])]
                 [phase-instructions-editor
                  (util/mmap ptc-id permit-type category-config selected-settings)
                  :entity.type/pre-consultation]])])

           ;; Archive on finish
           (when archiving-feature?
             [arch-on-fin-select/archive-on-finish-selector
              (util/mmap tr ptc-id permit-type category-config selected-settings)])])

        ;; Limit category visibility for other departments when restrict sibling is on
        (when (or restrict-sibling-enabled? (not hidden?))
          [visibility-checkbox (util/mmap ptc-id category-config permit-type-group-config selected-settings tr)])

        (when-not hidden?
          [:<>
           ;; Category description
           (when-not (or permit-type-ce?
                         permit-type-pi?
                         permit-type-pwo?)
             [:<>
              [:h4.mt-4.mb-2 (tr [:group-admin/category-description])]
              [:p (tr [:group-admin/category-description-instructions])]
              [:div {:on-click #(.stopPropagation %)}
               ^{:key (str cat-id "-description-v" (:version updated-ptc-config))}
               [group-config-rt-editor (util/mmap {:group-config  category-config
                                                   :attr          :group.config/category-description
                                                   ;; Default to dictionary descriptions if not in db
                                                   :default-value (when cat-keyword
                                                                    (<sub [::gas/default-category-description cat-keyword]))}
                                                  selected-settings
                                                  ptc-id)]]])


           (when (or permit-type-ce? permit-type-pwo?)
             [:<>
              ;; Initial inspection creation
              (let [checked? (get-in selected-settings
                                     [cat-id :group.config/do-not-create-initial-inspection]
                                     (:group.config/do-not-create-initial-inspection category-config))]
                [:div.mb-4 {:on-click #(.stopPropagation %)}
                 (cc/checkbox {:id         (str "initial-inspection:" ptc-id)
                               :class-name "mr-2"
                               :label-text (tr [:group.config/do-not-create-initial-inspection])
                               :checked    (boolean checked?)
                               :on-change  (fn [value]
                                             (>evt [::gas/update-ptc-group-config-changes
                                                    ptc-id
                                                    cat-id
                                                    #(assoc % :group.config/do-not-create-initial-inspection value)]))})])

              ;; Require photo with submission
              (when complaint-submission-config? ; the feature flag is for all developments made in WIN-4382
                (let [photos-enabled? (<sub [::gas/has-feature? :group.feature/complaint-photos])
                      checked?        (get-in selected-settings
                                              [cat-id :group.config/require-photo-with-submission?]
                                              (:group.config/require-photo-with-submission? category-config))]
                  [:div.mb-4 {:on-click #(.stopPropagation %)}
                   (cc/checkbox {:id         (str "require-photo:" ptc-id)
                                 :class-name "mr-2"
                                 :label-text (tr [:group.config/require-photo-with-submission?])
                                 :checked    (boolean checked?)
                                 :disabled   (not photos-enabled?)
                                 :on-change  (fn [value]
                                               (>evt [::gas/update-ptc-group-config-changes
                                                      ptc-id
                                                      cat-id
                                                      #(assoc % :group.config/require-photo-with-submission? value)]))})
                   (when-not photos-enabled?
                     [ui/help (tr [:group.config/require-photo-with-submission-deactivated])])]))])

           ;; Neighbor selection radius
           (when (public-notice-model/enabled-for? permit-type)
             (let [saved-radius   (:group.config/neighbour-radius category-config)
                   radius         (get-in selected-settings [cat-id :group.config/neighbour-radius]
                                          saved-radius)
                   max-radius     (<sub [::neighbour-subs/max-neighbour-radius])
                   default-radius (<sub [::neighbour-subs/default-neighbour-radius])
                   unit-label     (<sub [::sou-toggle/label-in-default-system :m])]
               [:<>
                [:h4.mt-8.mb-2 (tr [:group-admin/neighbour-radius])]
                [:p.pre-line (tr [:group-admin/neighbour-radius-instructions]
                                 [default-radius
                                  unit-label])]
                [ui/number-input
                 {:id           (str cat-id "-neighbour-radius")
                  :value        radius
                  :min          0
                  :max          max-radius
                  :placeholder  default-radius
                  :unit-label   unit-label
                  :invalid-text (tr [:group-admin/neighbour-radius-invalid] [max-radius])
                  :invalid      (and (number? radius)
                                     (not (workspace-model/valid-neighbour-radius? max-radius radius)))
                  :on-change    (fn [v]
                                  (let [new-value (-> v futil/tval futil/parse-int)]
                                    (rf/dispatch-sync [::gas/update-ptc-group-config-changes
                                                       ptc-id
                                                       cat-id
                                                       #(if (= saved-radius new-value)
                                                          (dissoc % :group.config/neighbour-radius)
                                                          (assoc % :group.config/neighbour-radius new-value))])))
                  :light        true}]]))

           ;; Project type selection
           ;; TODO: to be removed completely in WIN-5423
           (when (and (not application-wizard?) any-project-types?)
             (let [saved-types (some-> category-config
                                       :group.config/project-types
                                       seq
                                       set)]
               [:<>
                [:h4.mt-8.mb-2 (tr [:project-types])]
                [:p.pre-line (tr [:group-admin/project-type-instructions])]
                (for-frag [project-type (<sub [::gas/all-project-types])
                           :let [checked? (-> (get-in selected-settings [cat-id :group.config/project-types]
                                                      saved-types)
                                              set
                                              (contains? project-type))]]
                  [:div {:on-click #(.stopPropagation %)}
                   (cc/checkbox {:id         (str cat-id "-" project-type)
                                 :label-text (tr [project-type])
                                 :checked    checked?
                                 :on-change  (fn [v]
                                               (let [op (if v conj disj)]
                                                 (>evt [::gas/update-ptc-group-config-changes
                                                        ptc-id
                                                        cat-id
                                                        (fn [config-changes]
                                                          (let [type-changes (:group.config/project-types config-changes)
                                                                new-types    (if type-changes
                                                                               (op type-changes project-type)
                                                                               (op saved-types project-type))]
                                                            (if (= new-types saved-types)
                                                              (dissoc config-changes :group.config/project-types)
                                                              (assoc config-changes :group.config/project-types (set new-types)))))])))})])]))])

        ;; Archiving settings
        (when (seq archiving-field-schemas)
          [:h4.mb-2.mt-8 (tr [:archiving/archiving-fields])])
        (for-frag [archiving-field-schema archiving-field-schemas]
          [archiving-config/editor-for-archiving-field-config
           (util/mmap tr ptc-id permit-type category-config selected-settings)
           archiving-field-schema])
        (when archiving-feature?
          [archiving-config/workspace-sensitivity-selector
           (util/mmap tr ptc-id permit-type category-config selected-settings)])

        ;; Work types and targets
        (when (and (not hidden?)
                   (not (contains? ptc-model/execution-only-types permit-type))
                   (or (seq (:entity/_parent category-config))
                       crud-allowed?))
          [:<>
           [:h4.mt-8.mb-2 (tr [:work-types])]
           (for-frag [work-type-config (<sub [::gas/child-group-configs-sorted cat-id #{:group-config.state/enabled
                                                                                        :group-config.state/disabled}])]
             [work-type-config-editor (util/mmap {:ancestor-configs [category-config]}
                                                 permit-type
                                                 work-type-config
                                                 ptc-id
                                                 selected-settings
                                                 group-id
                                                 crud-allowed?
                                                 tr
                                                 lang)])
           (when crud-allowed?
             [new-subtype-editor (util/mmap {:parent-id    (:db/id category-config)
                                             :config-level :group-config.level/work-type}
                                            group-id
                                            tr
                                            permit-type)])
           (when (and (not (contains? ptc-model/permit-types-with-multiple-work-types permit-type))
                      (<sub [::gas/work-types-with-targets-exist? (:db/id category-config)]))
             [default-work-type-target/selector
              (util/mmap ptc-id selected-settings tr permit-type category-config)])])])]))


(defn save-cancel-buttons [tr group-id permit-type ptc-id]
  (let [cancel-disabled? (not (<sub [::permit-type-config-changed? permit-type ptc-id]))
        save-disabled?   (or cancel-disabled?
                             (not (<sub [::valid-settings? ptc-id])))
        processing?      (<sub [::gas/saving-ptc-edits?])]
    [ui-action-buttons/save-cancel-buttons
     (util/mmap {:on-cancel        #(>evt [::gas/clear-ptc-edits ptc-id])
                 :cancel-disabled? cancel-disabled?
                 :on-save          #(>evt [::gas/save-ptc-edits group-id ptc-id])
                 :save-disabled?   save-disabled?
                 :size             :small
                 :loading?         processing?}
                tr)]))


(defn permit-type-config-editor
  "Editor for selecting configuring authority group categories, work types and work targets"
  [{:keys [tr group-id crud-allowed? category-configs can-desc?]}
   {:permit-type-config/keys [permit-type hidden? permit-type-descriptions]
    :as                      ptc}]
  (let [ptc-id                    (:db/id ptc)
        updated-ptc-config        (<sub [::ptc-settings-in-editor permit-type ptc-id])
        archiving-feature?        (<sub [::gas/has-feature? :group.feature/archiving])
        root-group-config         (<sub [::gas/root-group-config permit-type])
        archiving-field-schemas   (<sub [::archiving-field-schemas permit-type])
        description-map           (or (:permit-type-descriptions updated-ptc-config)
                                      (i18n-model/strings-map permit-type-descriptions))
        selected-settings         (:group-config-settings updated-ptc-config)
        restrict-sibling-enabled? (<sub [::ff/enabled? :feature-flag.id/restrict-workspace-access-to-sibling-authorities])]
    [:form.admin-config-form {}
     ;; Permit description not needed for supplemental building permits or code enforcement
     (when can-desc?
       [:div.bx--row
        [:div.bx--col-xs-12.bx--col-xl-9.bx--col-xxl-8.mb-4
         [:h4.mb-2 (tr [:group-admin/permit-type-description])]
         [ui/help (tr [:group-admin/permit-type-description-info])]
         [ui-i18n/edit-language-selector {:allowed-locales-sub ::gas/allowed-locales}]
         [ui-i18n/localized-rich-text-editor
          {:id                  (str ptc-id "-description")
           :key                 (str ptc-id "-description-" (:version updated-ptc-config))
           :strings             description-map
           :on-change           (fn [value]
                                  (>evt [::gas/set-ptc-edit-val
                                         ptc-id
                                         :permit-type-descriptions
                                         value]))
           :allowed-locales-sub ::gas/allowed-locales}]]])

     [:div.bx--row
      [:div.bx--col-xs-12.bx--col-xl-9.bx--col-xxl-8
       (when restrict-sibling-enabled?
         [visibility-checkbox (util/mmap {:permit-type-group-config root-group-config}
                                         ptc-id selected-settings tr)])

       (when (seq category-configs)
         ;; WIN-5423 remove project-type code after wizard is deployed
         (let [any-project-types? (some #(-> % :group.config/project-types seq) category-configs)]
           [:<>
            [:h4.mb-3 (tr [:categories])]
            (for-frag [category-config category-configs]
              [category-config-editor (util/mmap {:permit-type-group-config root-group-config} ptc-id permit-type updated-ptc-config category-config hidden? tr
                                                 archiving-feature? archiving-field-schemas group-id crud-allowed? any-project-types?)])]))
       (when crud-allowed?
         [new-subtype-editor (util/mmap {:parent-id    (:db/id root-group-config)
                                         :config-level :group-config.level/category}
                                        group-id
                                        tr
                                        permit-type)])]]
     [save-cancel-buttons tr group-id permit-type ptc-id]]))

(defn permit-type-configs-section [tr group-id & [section-options]]
  (let [permit-type-configs (<sub [::gas/permit-type-configs])
        admin?              (<sub [:session/admin?])
        lang                (<sub [:language])]
    [acommon/config-section
     (tr [:group-admin/permit-types])
     (tr [:group-admin/permit-type-instruction])
     section-options
     [copy-gc/copy-gc-modal]
     (for-frag [ptc permit-type-configs
                :when (seq ptc)
                :let [{:permit-type-config/keys [permit-type hidden?]} ptc
                      root-group-config (<sub [::gas/root-group-config permit-type])
                      custom-name       (some-> root-group-config :group.config/names
                                                (i18n-model/get-text-from-entities-or-map lang))
                      category-configs  (<sub [::gas/category-group-configs permit-type])
                      name-map          (or (-> root-group-config :group.config/names i18n-model/strings-map)
                                            {})
                      config-id         (:db/id root-group-config)
                      editing?          (<sub [::edited-permit-subtype-names config-id])
                      crud-allowed?     (and (not hidden?)
                                             (or admin?
                                                 (ptc-model/permit-types-with-editable-subtypes permit-type)))
                      can-desc?         (not (config-model/permit-types-without-description permit-type))]]
       [:<>
        (if editing?
          [:div.py-2.w-full
           {:on-click #(.stopPropagation %)
            :class    "px-5"}
           [permit-type-label-editor (util/mmap {:group-id     (-> root-group-config :group.config/group :db/id)
                                                 :config-level (-> root-group-config :group.config/level)}
                                                root-group-config config-id tr lang)]]
          [:div.mb-8.flex {:on-click #(.stopPropagation %)}
           [:h3.mb-0 (or custom-name
                         (tr [permit-type]))]
           (when-not hidden?
             (cc/button
               {:class-name       "only-icon-button ml-2"
                :kind             :ghost
                :size             :small
                :icon             i/pen
                :icon-description (tr [:edit])
                :icon-position    :right
                :on-click         #(>evt [::set-permit-subtype-edited-names config-id name-map])}
               ""))])
        ^{:key (:db/id ptc)}
        [permit-type-config-editor (util/mmap tr group-id crud-allowed? category-configs can-desc?) ptc]])]))
